// extracted by mini-css-extract-plugin
var _1 = "CardElement_active__1ce84";
var _2 = "CardElement_book__eeb0e";
var _3 = "CardElement_bookAnimating__2c4fa";
var _4 = "CardElement_cardFlip__b6366";
var _5 = "CardElement_cardUnFlip__93233";
var _6 = "CardElement_content__91a42";
var _7 = "CardElement_diagonalFlip__cdf4e";
var _8 = "CardElement_fadeEffect__af527";
var _9 = "CardElement_fill__f87a2";
var _a = "CardElement_horizontalFlip__bea74";
var _b = "CardElement_icon__33060";
var _c = "CardElement_left__42f9e";
var _d = "CardElement_leftFull__c7d24";
var _e = "CardElement_pauseAnimation__a61c3";
var _f = "CardElement_right__c8add";
var _10 = "CardElement_rightFull__796bc";
var _11 = "CardElement_root__ef7d8";
var _12 = "CardElement_transparentBack__65225";
var _13 = "CardElement_transparentFront__e52ec";
var _14 = "CardElement_verticalFlip__12391";
export { _1 as "active", _2 as "book", _3 as "bookAnimating", _4 as "cardFlip", _5 as "cardUnFlip", _6 as "content", _7 as "diagonalFlip", _8 as "fadeEffect", _9 as "fill", _a as "horizontalFlip", _b as "icon", _c as "left", _d as "leftFull", _e as "pauseAnimation", _f as "right", _10 as "rightFull", _11 as "root", _12 as "transparentBack", _13 as "transparentFront", _14 as "verticalFlip" }
